<oth-card *ngIf="testimonial.reviewer.name" [bodyTemplate]="bodyTemplate" [headerTemplate]="headerTemplate"
          class="testimonial-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <div [class]="testimonial.theme" class="header">
      <i [style.color]="testimonial.theme" aria-hidden="true" class="fas fa-quote-left fa-lg fa-fw"></i>
    </div>
  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div [class]="testimonial.theme" class="body">
      <div class="review">
        <p>
          {{ testimonial.review }}
        </p>
      </div>
      <div class="reviewer">
        <svg style="min-height: 210px;" xmlns="http://www.w3.org/2000/svg">
          <path class="svg-path"
                d="M28.9,-40.6C39.8,-43.8,52.4,-40.7,53.9,-32.9C55.4,-25,45.8,-12.5,45.4,-0.2C44.9,12,53.7,24,49.3,26.9C45,29.8,27.5,23.6,17.1,32.7C6.7,41.9,3.4,66.3,-3.1,71.6C-9.5,76.9,-18.9,63.1,-26.9,52.5C-34.8,42,-41.2,34.7,-48.2,26.5C-55.3,18.3,-63,9.2,-64.9,-1.1C-66.9,-11.4,-63.1,-22.8,-59.3,-36.6C-55.4,-50.4,-51.6,-66.6,-41.7,-63.9C-31.9,-61.2,-15.9,-39.7,-3.4,-33.8C9,-27.8,18.1,-37.4,28.9,-40.6Z"
                fill-opacity="0.4" transform="translate(100 100)"></path>
        </svg>
        <img [src]="testimonial.reviewer.photoUri"
             alt="logo" class="profile-image" height="100" onerror="this.src='./assets/common/profile-img.png'"
             width="100"/>
        <div class="social">
          <app-ext-link [href]="testimonial.reviewer.social.twitter">
            <i [class]="'fab fa-' + environmentCommon.website.twitter.cssClass + ' fa-2x fa-fw'"
               aria-hidden="true" body>
            </i>
          </app-ext-link>
          <app-ext-link [href]="testimonial.reviewer.social.linkedIn">
            <i [class]="'fab fa-' + environmentCommon.website.linkedin.cssClass + ' fa-2x fa-fw'"
               aria-hidden="true" body>
            </i>
          </app-ext-link>
        </div>
      </div>
      <div class="reviewer-info">
        <small class="name">
          {{testimonial.reviewer.name}}
        </small>
        <small class="title">
          {{testimonial.reviewer.title}}
        </small>
      </div>
    </div>
  </ng-template>
</oth-card>
